    <div class="home-content" style="margin-bottom:70px;">
        <embed src="https://software.laoskyway.com:8012/chkticket/" style="width:100%; height: 95%;">
    </div>